var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-offline',{on:{"detected-condition":_vm.handleOfflineChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }